import {Button} from '@mui/material';
import React from 'react';
import styled from '@emotion/styled';


const StyledButton = styled(Button)`
padding: 12px 25px;
background-color: #030930;
border-radius: 20px;
color: #FFF;
text-transform: none;
:hover{
  background-color: #030930;
}
`;



const CustomButton = (props) => {
    const { children, style } = props; 
  return (
    <StyledButton style={style} {...props}>
      {children}
    </StyledButton>
  )
}

export default CustomButton